// Types
import type { ApplicationProps } from '@/types/config'

const config: ApplicationProps = {
	name: 'Regiti',
	shortName: 'Regiti'
}

export default config
